import { useEffect, useRef, useState } from 'react';
import { processoData } from '@/mocks/homeData';

export default function Processo() {
  const ref = useRef<HTMLElement>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setInView(true);
      },
      { threshold: 0.15 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section
      id="processo"
      ref={ref}
      className="bg-cream py-28 md:py-36 lg:py-44"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
        <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-extralight text-black tracking-tight text-center mb-14 md:mb-20">
          {processoData.title}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          {processoData.steps.map((step, i) => (
            <div
              key={step.number}
              className={`bg-white/60 backdrop-blur-sm p-8 md:p-10 rounded-sm ${
                inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              } transition-all duration-700 ease-editorial`}
              style={{ transitionDelay: `${i * 150}ms` }}
            >
              <span className="text-4xl md:text-5xl font-extralight text-terracota/40 tracking-tight block mb-6">
                {step.number}
              </span>
              <h3 className="font-display text-xl md:text-2xl font-normal text-black tracking-tight mb-4">
                {step.title}
              </h3>
              <p className="font-body text-sm font-light text-brand-gray-body leading-[1.7]">
                {step.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}